export let exportInfoMenu = [

    {
        url: "/info-products",
        i18n: "PRODUCTS",
        icon: "uil-shopping-cart",
        active: false,
    },
]